<template>
    <div class="Classroom" v-loading="loading">
        <div class="banners">
            <img src="../../../assets/img/index/law/banner1.png" alt="">
        </div>
        <div class="checks">
            <div class="check_box">
                <div class="check_item" v-for="(item, index) in check_list" :key="index" @click="handle_type(item)">
                    <div class="check_img">
                        <img :src="item.img_src" alt="">
                    </div>
                    <div class="check_info">
                        <div class="check_title">{{ item.title }}</div>
                        <div class="check_list">
                            <div class="check_list_item" v-for="(items, indexs) in item.child" :key="indexs">{{
                                items.title }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="Hotspot_recommendation">
            <div class="Hotspot_recommendation_box">

                <div class="titles_box">
                    <div class="title_text1">热点推荐</div>
                    <div class="title_text2">
                        HOTSPOT RECOMMENDATION
                        <img src="@/assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
                <div class="gpt_rec_flex">
                    <div class="gpt_rec_left" @click="handle_nwe(tj_ac)">
                        <div class="left_img">
                            <!-- <img src="../../../assets/img/index/legal/bg1.png" alt=""> -->
                             <img :src="tj_ac.thumb" alt="">
                        </div>
                        <!-- {{ tj_ac }} -->
                        <div class="left_titles">
                            {{ tj_ac.title }}
                        </div>
                        <div class="left_times">贷款纠纷 · {{ tj_ac.created_at }}</div>
                        <div class="left_consts">
                            {{ tj_ac.description }}
                            <span class="btns_a">查看全文</span>
                        </div>
                    </div>
                    <div class="gpt_rec_right">
                        <div class="right_lists">
                            <div class="items" v-for="(item, index) in nwe_tj_list" :key="index" @click="handle_nwe(item)">
                                <div class="item_title">
                                    {{ item.title }}
                                    <img src="@/assets/img/index/legal/title_bg.png" alt="">
                                </div>
                                <div class="item_const">
                                    {{ item.description }}<span
                                        class="item_btns">查看全文</span>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="Recommend_a_lawyer">
            <div class="Recommend_a_lawyer_box">
                <div class="titles_box">
                    <div class="title_text1">律师推荐</div>
                    <div class="title_text2">
                        RECOMMEND A LAWYER
                        <img src="@/assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
                <div class="list_item">
                    <div class="item" v-for="(item, index) in ls_list" :key="index" @click="handle_ls(item)">
                        <div class="item_left">
                            <div class="item_left_tops">
                                <div class="item_title">{{ item.name }}</div>
                                <div class="item_firm">{{ item.work_company }}</div>
                                <div class="item_tage">{{ item.serve }}</div>
                            </div>
                            <div class="item_left_boms">
                                <div class="btns1">立即咨询</div>
                            </div>
                        </div>
                        <div class="item_right">
                            <!-- <img src="../../../assets/img/index/home/lsimg.png" alt=""> -->
                            <img :src="item.business_img" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="News_hotspot">
            <div class="News_hotspot_box">
                <div class="titles_box">
                    <div class="title_text1">新闻热点</div>
                    <div class="title_text2">
                        NEWS HOTSPOT
                        <img src="@/assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
                <div class="check_type">
                    <div class="tab_list" v-for="(item, index) in check_list2" :key="index"
                        :class="{ tab_list_ac: cehck_ac.id == item.id }" @click="handle_cehck(item, index)">
                        <div class="tab_title">
                            {{ item.title }}
                        </div>
                        <div class="borders"></div>
                    </div>
                </div>
                <div class="check_item">
                    <div class="item_ac_left">
                        <div class="left_title">{{ cehck_ac.title }}</div>
                        <div class="left_texts">{{cehck_ac.description}}</div>
                        <!-- <div class="left_nums"><span>13</span>细分领域</div> -->
                        <div class="left_nums2"><span>{{ nwe_length }}</span>+精选文章</div>
                        <div class="left_btns" @click="handle_cehck_ac_path">进入专区</div>
                    </div>
                    <div class="item_ac_right">
                        <div class="items" v-for="(item,index) in nwe_list2" :key="index" @click="handle_nwe(item)">
                            <div class="item_img">
                                <!-- <img src="../../../assets/img/index/legal/bg1.png" alt=""> -->
                                 <img :src="item.thumb" alt="">
                            </div>
                            <div class="item_info">
                                <div class="item_title">
                                    {{ item.title }}
                                </div>
                                <div class="item_const">
                                    {{ item.description }}<span>查看全文</span>
                                </div>
                                <div class="item_icons">
                                <div class="icons">
                                    <img src="../../../assets/img/index/comments_case/time.png" alt="">
                                    {{ item.created_at }}
                                </div>
                                <div class="icons">
                                    <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                    {{ item.view_num }}

                                </div>
                            </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="Featured_Cases">
            <div class="Featured_Cases_box">
                <div class="titles_box">
                    <div class="title_text1">精选案例</div>
                    <div class="title_text2">
                        FDATURED CASES
                        <img src="@/assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
                <div class="list_box">
                    <div class="items" v-for="(item,index) in caseList" :key="index" @click="handle_case(item)">
                        <div class="item_title">
                            {{ item.title }}
                        </div>
                        <div class="item_const">
                            {{ item.desc }}
                        </div>
                        <div class="item_icons">
                            <div class="icons">
                                <img src="../../../assets/img/index/comments_case/see.png" alt="">
                                {{ item.views }}
                            </div>
                            <div class="icons">
                                <img src="../../../assets/img/index/comments_case/pl_num.png" alt="">
                                {{ item.comment_num }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>
<script>
import { useListeners } from 'vue';
import {
    mapState
} from 'vuex'



export default {
    components: {

         
    },
    name: "homes",
    data() {
        return {
            loading: false,
            check_list: [],
            cehck_ac: {},
            check_list2: [],
            nwe_list2:[],
            nwe_length:0,
            nwe_tj_list:[],
            tj_ac:{},
            ls_list:[],
            caseList:[],
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_ls_list()
        this.get_check_list()
        this.get_check_list2()
        this.get_nwe_tj_list()
        this.get_caseList()
    },
    methods: {
        handle_cehck_ac_path(){

          this.$router.push({
            path:'/hot_spot_type',
            query:{
                id:this.cehck_ac.id,
                parent_id:4,
            },
          })
        },
        handle_case(item){
            this.$router.push({
                path:'/comments_detial',
                query:{
                    id:item.id
                },
            })
        },
        handle_type(item){
            this.$router.push({
                path:'/hot_spot_type',
                query:{
                    id:item.id
                },
            })
        },
        handle_ls(item){
            this.$router.push({
                path:'/lawyer_detial',
                query:{
                    id:item.id
                },
            })
        },
       
        handle_cehck(item, index) {
            this.cehck_ac = item
            this.get_check_list2_new()
        },
        handle_nwe(item){
            this.$router.push({
                path:'/hot_spot_type_detial',
                query:{
                    id:item.id
                }
            })
        },
        get_ls_list(){
            this.loading=true
            this.$api("lawyers", {
                recommend:1,
                limit:3,
			}, "get").then((res) => {
                this.loading = false
                console.log('律师推荐',res)
                if (res.code == 1) {
                    
                    this.ls_list=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_nwe_tj_list(){
            this.loading=true
            this.$api("getArticleList", {
                category_id:29,
                limit:4,
			}, "get").then((res) => {
                this.loading = false
                console.log('热点推荐',res)
                if (res.code == 1) {
                    this.nwe_tj_list=res.data.list
                    this.tj_ac=res.data.list[0]
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_check_list(){
            this.loading=true
            this.$api("getArticleCategoryList", {
                // parent_id:19,
			}, "get").then((res) => {
                this.loading = false
                console.log('首页法界热点分类1',res)
                if (res.code == 1) {
                    res.data.forEach((e)=>{
                        if(e.id==2){
                            e.child.forEach((v)=>{
                                if(v.id==19){
                                    this.check_list=v.child
                                }
                            })
                        }
                    })
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_check_list2(){
            this.loading=true
            this.$api("getArticleCategoryList", {
                parent_id:4,
			}, "get").then((res) => {
                this.loading = false
                console.log('首页法界热点分类1',res)
                if (res.code == 1) {
                    this.check_list2=res.data
                    this.cehck_ac=res.data[0]
                    this.get_check_list2_new()
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_check_list2_new(){
            this.loading=true
            this.$api("getArticleList", {
                category_id:this.cehck_ac.id,
                limit:3,
			}, "get").then((res) => {
                this.loading = false
                console.log('新闻热点',res)
                if (res.code == 1) {
                    this.nwe_list2=res.data.list
                    this.nwe_length=res.data.count
                    
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_caseList(){
            this.loading=true
            this.$api("caseList", {
                limit:4,
            }, "get").then((res) => {
                this.loading = false
                console.log('案例点评',res)
                if (res.code == 1) {
                    this.caseList=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
    },

}
</script>
<style scoped lang="less">
.Classroom {
    width: 100%;
    // height: 680px;
    // background-color: ;
    // padding:21px ;
    // padding-bottom: 100px;

    .banners {
        width: 100%;
        height: 480px;
        position: relative;
        z-index: 1;

        img {
            width: 100%;
            height: 480px;
        }
    }

    .checks {
        width: 100%;
        background: #FFFFFF;

        .check_box {
            width: 1440px;
            height: 258px;
            background: #FFFFFF;
            box-shadow: 2px 2px 10px 1px rgba(1, 9, 46, 0.1);
            border-radius: 8px 8px 8px 8px;
            margin: auto;
            margin-top: -149px;
            position: relative;
            z-index: 2;
            padding: 40px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .check_item {
                width: 25%;
                // padding-right: 30px;
                // height: 50%;
                margin-bottom: 30px;
                display: flex;
                cursor: pointer;

                .check_img {
                    img {
                        width: 32px;
                    }
                }

                .check_info {
                    padding-left: 16px;

                    .check_title {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;

                    }

                    .check_list {
                        width: 240px;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        padding-top: 6px;

                        .check_list_item {
                            margin-right: 24px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 12px;
                            color: #999999;
                            margin-bottom: 6px;
                        }
                    }

                }

            }
        }
    }

    .titles_box {
        display: flex;
        align-items: end;

        .title_text1 {
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 36px;
            color: #333333;
        }

        .title_text2 {
            padding-left: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #B3CDFE;

            img {
                width: 24px;
                height: 24px;
                margin-left: 15px;
                vertical-align: middle;
            }
        }

    }

    .Hotspot_recommendation {
        padding-top: 56px;
        padding-bottom: 50px;

        .Hotspot_recommendation_box {
            width: 1440px;
            margin: auto;

            .gpt_rec_flex {
                display: flex;
                padding-top: 40px;

                .gpt_rec_left {
                    width: 440px;

                    .left_img {
                        width: 440px;
                        height: 293px;

                        img {
                            width: 440px;
                            height: 293px;
                        }
                    }

                    .left_titles {
                        padding-top: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 1;
                        -webkit-box-orient: vertical;
                    }

                    .left_times {
                        padding-top: 10px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 12px;
                        color: #999999;

                    }

                    .left_consts {
                        width: 100%;
                        // display: flex;
                        // align-items: center;
                        word-break: break-all;
                        word-wrap: break-word;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        padding-top: 16px;
                        color: #666666;

                        .btns_a {
                            color: #377CFD;
                            cursor: pointer;
                        }
                    }
                }

                .gpt_rec_right {
                    padding-left: 48px;

                    .right_lists {
                        .items {
                            cursor: pointer;
                            margin-bottom: 32px;

                            .item_title {
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 18px;
                                color: #333333;

                                img {
                                    margin-left: 12px;
                                    width: 19px;
                                }
                            }

                            .item_const {
                                padding-top: 16px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;

                                .item_btns {
                                    color: #377CFD;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .Recommend_a_lawyer {
        background-color: #F5F5F5;
        padding-top: 64px;
        padding-bottom: 82px;

        .Recommend_a_lawyer_box {
            width: 1440px;
            margin: auto;

            .list_item {
                display: flex;
                align-items: center;
                // justify-content: space-between;
                padding-top: 48px;

                .item {
                    width: 458px;
                    min-height: 258px;
                    background: #FFFFFF;
                    border-radius: 8px 8px 8px 8px;
                    display: flex;
                    // align-items: center;
                    padding: 32px 15px 0 24px;
                    margin-right: 33px;
                    justify-content: space-between;
                    &:last-child{
                        margin: 0;
                    }
                    .item_left {
                        width: 180px;
                        display: flex;
                        flex-wrap: wrap;
                        align-content: space-between;

                        .item_left_tops {
                            width: 100%;

                            .item_title {
                                font-weight: bold;
                                font-size: 24px;
                                color: #333333;
                                word-break: break-all;
                            }

                            .item_firm {
                                font-weight: bold;
                                font-size: 14px;
                                color: #333333;
                                padding-top: 10px;
                            }

                            .item_tage {
                                padding-top: 20px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                word-break: break-all;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp:2;
                                -webkit-box-orient: vertical;
                            }
                        }

                        .item_left_boms {
                            // display: flex;
                            // align-items: center;
                            padding-bottom: 30px;

                            .btns1 {
                                width: 180px;
                                height: 40px;
                                background: #377CFD;
                                border-radius: 4px 4px 4px 4px;
                                text-align: center;
                                line-height: 40px;
                                cursor: pointer;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #FFFFFF;

                            }
                        }
                    }

                    .item_right {
                        width: 224px;
                        height: 100%;
                        overflow: hidden;
                        flex-shrink: 0;

                        img {
                            width: 224px;
                        }
                    }
                }
            }
        }
    }

    .News_hotspot {
        padding-top: 62px;
        padding-bottom: 80px;

        .News_hotspot_box {
            width: 1440px;
            margin: auto;
            .check_type {
                display: flex;
                align-items: center;
                padding-top: 50px;
                // padding-bottom: 20px;
                border-bottom: 2px solid #EDEDED;

                .tab_list {
                    margin-right: 80px;
                    cursor: pointer;

                    // height: 100%;
                    .tab_title {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 18px;
                        color: #999999;
                    }

                    .borders {
                        width: 72px;
                        height: 3px;
                        background: #fff;
                        margin-top: 18px;
                        border-radius: 0px 0px 0px 0px;
                    }

                    &:hover {
                        .tab_title {
                            color: #377CFD;
                        }

                        .borders {
                            background: #377CFD;
                        }
                    }
                }

                .tab_list_ac {
                    .tab_title {
                        color: #377CFD;
                    }

                    .borders {
                        background: #377CFD;
                    }
                }
            }
            .check_item{
                padding-top: 40px;
                display: flex;
                align-items: center;
                .item_ac_left{
                    width: 420px;
                    height: 400px;
                    background: #F7F7F7;
                    border-radius: 8px 8px 8px 8px;
                    padding: 46px 32px ;
                    .left_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 24px;
                        color: #333333;

                    }
                    .left_texts{
                     padding-top: 15px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;

                    }
                    .left_nums{
                        padding-top: 40px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        span{
                            color: #333333;
                            font-size: 36px;
                            font-weight: bold;
                        }
                    }
                    .left_nums2{
                      
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        span{
                            color: #333333;
                            font-size: 36px;
                            font-weight: bold;
                        }

                    }
                    .left_btns{
                        width: 180px;
                        height: 40px;
                        background: #377CFD;
                        border-radius: 4px 4px 4px 4px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 40px;
                        cursor: pointer;
                        margin-top: 56px;
                    }
                }
                .item_ac_right{
                    display: flex;
                    align-items: center;
                    // justify-content: space-between;
                    flex: 1;
                    padding-left: 24px;
                    .items{
                        width: 316px;
                        height: 400px;
                        background: #FFFFFF;
                        border-radius: 8px 8px 8px 8px;
                        border: 1px solid #D7D7D7;
                        margin-right: 24px;
                        &:last-child{
                            margin: 0;
                        }
                        .item_img{
                            width: 100%;
                            height: 216px;
                            img{
                                width: 100%;
                                height: 216px;
                            }
                        }
                        .item_info{
                            padding:16px 16px 24px 16px;
                            .item_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #333333;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp:1;
                                -webkit-box-orient: vertical;
                            }
                            .item_const{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 12px;
                                color: #666666;
                                padding-top: 16px;
                                span{
                                    cursor: pointer;
                                    color: #377CFD;
                                }
                            }
                        }
                        .item_icons{
                            display: flex;
                            align-items: center;
                            padding-top: 20px;
                            .icons{
                                margin-right: 16px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                
                                img{
                                    width: 19px;
                                    // height: 19px;
                                }
                            }
                        }
                    }

                }

            }
        }


    }
    .Featured_Cases{
        background-color: #F5F5F5;
        padding-bottom: 100px;
        .Featured_Cases_box{
            width: 1440px;
            margin: auto;
            padding-top: 80PX;
            .list_box{
                padding-top: 37px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                .items{
                    width: 708px;
                    height: 236px;
                    background: #FFFFFF;
                    border-radius: 8px 8px 8px 8px;
                    margin-bottom: 20px;
                    padding: 32px 40px;
                    cursor: pointer;
                    .item_title{
                        width: 450px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 20px;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp:1;
                        -webkit-box-orient: vertical;
                    }
                    .item_const{
                       
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                        margin-top: 20px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp:2;
                        -webkit-box-orient: vertical;
                    }
                    .item_icons{
                        margin-top: 26px;
                        border-top: 1px solid #EDEDED;
                        padding-top: 26px;
                        display: flex;
                        align-items: center;
                        .icons{
                            display: flex;
                            align-items: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            margin-left:24px ;
                            img{
                                // width: 25px;
                                height: 15px;
                                margin-right: 8px;

                            }

                        }
                    }
                }
            }
        }
    }



}
</style>